<div [innerHTML]="content" class="cms-rich-text-content"></div>
